/*
 * ─── Product catalogue ──────────────────────────────────────────────────────
 *
 * The loan tiers a consumer applicant chooses between on Step 5, with the
 * rates the platform quotes and prices repayments against. Edit this file to
 * offer your own products — the form (tier cards, live repayment estimates)
 * and the backend (serviceability model, the rate sent to the lender) both
 * read from here, so the two sides can never drift.
 *
 * Rates are annual decimals (0.2599 = 25.99% p.a.). `comparison` is the
 * comparison rate shown beside the headline rate. Exactly one tier should be
 * `recommended`. Keep tier `id`s stable once files exist — they are stored on
 * applications (`selectedProduct`) and priced by the lender mapping.
 */
export default {
  /* Used to estimate repayments before a tier is chosen. */
  indicativeRate: 0.2599,

  tiers: [
    {
      id: "secured",
      name: "Secured",
      tagline: "Lowest rate · car as security",
      rate: 0.2599,
      comparison: 0.3724,
      recommended: true,
      perks: ["No monthly account fees", "Extra repayments anytime", "Fixed for the full term"],
    },
    {
      id: "flex",
      name: "Flex",
      tagline: "Balance of rate & flexibility",
      rate: 0.2599,
      comparison: 0.3724,
      recommended: false,
      perks: ["Redraw on extra repayments", "Repayment holidays available", "Fixed for the full term"],
    },
    {
      id: "easy",
      name: "Easy",
      tagline: "Lighter checks · faster approval",
      rate: 0.2599,
      comparison: 0.3724,
      recommended: false,
      perks: ["No early exit fees", "Approval in as little as 24h", "Great for non-standard income"],
    },
  ],
};
